import { render, staticRenderFns } from "./OrderOtherPriceTable.vue?vue&type=template&id=6e8ccb7e&scoped=true"
import script from "./OrderOtherPriceTable.vue?vue&type=script&lang=js"
export * from "./OrderOtherPriceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ccb7e",
  null
  
)

export default component.exports